export const trimUserId = (string) => {
  return string.slice(6);
}